import React from "react";
import {
    IControlStyles,
    PageContent,
    useControlStyles,
} from "../../../assets/layouts";
import { VfxLib } from "../../../assets/vfx";
import Control from "../../../assets/vfx/controls/control";
import { QuestionnaireResponseService } from "./questionnaireResponseService";

interface QuestionnaireResponsePageProps {
    questionnaireId?: string | undefined;
    controlStyles?: IControlStyles | undefined;
    onCustomEvent?: (actionType: string, dataId: string) => void;
}

export const QuestionnaireResponsePage = (props: QuestionnaireResponsePageProps) => {
    const questionnaireGridQuery = QuestionnaireResponseService.gridQuery(props.questionnaireId);
    const styles: IControlStyles = props.controlStyles ?? useControlStyles();
    return (
        <Control.DataGrid
            dataId="id"
            height="55vh"
            cols={[
                {
                    data: "id",
                    title: "ID",
                    visible: false,
                    columnType: "number",
                    alignment: "right",
                },
                {
                    data: "deviceName",
                    title: "Device",
                    visible: true,
                    columnType: "text",
                    alignment: "left",
                    sortable: false,
                    width: "24%",
                },
                //{
                //    data: "surveySubmittedDate",
                //    title: "Submit Date",
                //    visible: true,
                //    columnType: "date",
                //    alignment: "left",
                //    width: "24%",
                //},
            ]}
            actionCol={{
                data: "id",
                title: "Action",
                visible: true,
                columnType: "action",
                alignment: "right",
                width: "100px",
                controlStyles: styles,
                actionButtons: [
                    VfxLib.datagridActionButtons({ datagridStyles: styles }).view,
                ],
            }}
            onCustomEvent={props.onCustomEvent}
            data={questionnaireGridQuery?.data ?? []}
            isActionButtonClick={true}
        />
    );
};
